import { render, staticRenderFns } from "./VdpArticle.vue?vue&type=template&id=8248d0e0"
import script from "./VdpArticle.vue?vue&type=script&lang=js"
export * from "./VdpArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports